import { handleActions } from 'redux-actions';
import * as actions from './actions';

const defaultState = {
  draftSticker: null,
  showDraftContinueModal: false,
};

const reducer = handleActions(
  new Map([
    [actions.setDraftContinueModalVisibility,
      (state, action) => {
        return { ...state, showDraftContinueModal: action.payload };
      }],
    [actions.setDraftSticker,
      (state, action) => {
        return { ...state, draftSticker: action.payload };
      }],
  ]),
  defaultState
);

export default reducer;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/drafts/reducer.ts